// extracted by mini-css-extract-plugin
export default {"table":"table-YTdXZ","tableContainer":"tableContainer-c4IAQ","row":"row-PpVKT","cell":"cell-hXkU4","cellContainer":"cellContainer-UOjBW","title":"title-p5Rpi"};